import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const CheckCircleNotCheckedIcon = createIcon({
  displayName: 'CheckCircleNotCheckedIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18Z" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24H0Z" />
    </>
  ),
})

const CheckCircleNotChecked: FC<IconProps> = (props) => {
  return <CustomIcon as={CheckCircleNotCheckedIcon} {...props} />
}

export default memo(CheckCircleNotChecked)
